import { IGlobalEnvironment } from "@interfaces/iEnvironment";

export const globalEnvironment: IGlobalEnvironment = {
	buildDate:'2025-11-14T15:02:50.038Z',
	youtubeCookieNames: ['Youtube Cookies (ytimg)', 'YouTube Video', 'YouTube'],
	treePath: "/live-catalog-public/catalog/{key}/cache/tree_{encoding}.json",
	catalogLogoPath: "/live-catalog-public/catalog/{key}/logo/{size}/{key}.{format}",
	prefetchCatalogPath: "/api/v3/CatalogView/catalogKey/{key}",
	prefetchCatalogDetailsPath: "/api/v3/CatalogView/catalogItemGuid/{guid}/details",
	prefetchWatchlistInforamtionPath: "/api/v3/WatchList/information",
	prefetchCatalogItemMetaPath: "/api/v3/CatalogView/catalogItem/{guid}/meta",
	prefetchCatalogInfoPath: "/api/v3/CatalogView/catalogKey/{key}/meta",
	trackIntervalInSec: 5,
	helpdeskHeader: {
		solution: "ADE_FAQ",
		helpId: "180100001"
	},
	helpdeskCM: {
		solution: "ADE_CM",
		helpId: "180500000"
	}
}